export default "__VITE_ASSET__DRJEt5Jk__"